/**
 * @description Get the unix timestamp in seconds for the given date.
 *
 * @param {Date} date The date whose unix timestamp in seconds is returned.
 *
 * @returns {number} Unix timestamp in seconds.
 */
export var getUnixTime = function (date) { return Math.floor(date.getTime() / 1000); };
//# sourceMappingURL=getUnixTime.js.map